module.exports = __webpack_public_path__ + "mo/img/img_03.3a1b2cf4.webp";